import { SVGProps, Ref, forwardRef } from "react";

const SendEmailIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 26 26"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Send Mail Icon"
    {...props}
  >
    <title id="Send Email Icon">Send Email Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.25 14.75 23.5 2.5M11.399 15.133l3.066 7.884c.27.695.405 1.042.6 1.143.168.088.37.088.538 0 .195-.1.33-.448.601-1.142l7.689-19.702c.244-.627.367-.94.3-1.14a.583.583 0 0 0-.369-.37c-.2-.066-.513.056-1.14.3L2.982 9.797c-.695.27-1.042.406-1.143.6a.583.583 0 0 0 0 .54c.102.194.45.329 1.144.599l7.884 3.066c.141.055.211.082.27.125a.58.58 0 0 1 .137.136c.042.06.07.13.125.27Z"
    />
  </svg>
);

const ForwardRef = forwardRef(SendEmailIcon);
export default ForwardRef;
